import React from 'react';
import { StyleSheet } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';

import LockIcon from '@/assets/icons/lock-sm';
import { Odds } from '@/components/Odds';
import { SizedBox } from '@/components/SizedBox';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

import { useFeaturedBetActions } from '../hooks/use-featured-bet-actions';
import { useSelectionInfo } from '../hooks/use-selection-info';
import { FeaturedBet } from '../types';

type AddBetButtonProps = {
    testID?: string;
    featuredBet: FeaturedBet;
};

export const AddBetButton = ({ testID, featuredBet }: AddBetButtonProps) => {
    const selections = featuredBet.events.flatMap(e => e.selections);
    const oddDetails = featuredBet.odds;

    const { addFeaturedBet, removeFeaturedBet } = useFeaturedBetActions();

    const { isSuspended, isAlreadySelected } = useSelectionInfo(selections);

    const toggleSelection = () => {
        if (isAlreadySelected) {
            removeFeaturedBet(selections.map(s => s.option.id));
        } else {
            addFeaturedBet(featuredBet);
        }
    };

    return (
        <Box flexGrow={1}>
            <TouchableOpacity onPress={toggleSelection} disabled={isSuspended} testID={`${testID}`}>
                <Box
                    borderRadius="r10"
                    backgroundColor={
                        isAlreadySelected
                            ? ds.colorToken.background.neutral.inverse
                            : ds.colorToken.background.neutral.subtler
                    }
                    alignItems="center"
                    justifyContent="center"
                    paddingVertical="s12"
                    paddingHorizontal="s16"
                    height={44}
                >
                    {isSuspended ? (
                        <Box flex={1} justifyContent="center" alignItems="center">
                            <LockIcon color={designSystem.colors.neutral400} />
                        </Box>
                    ) : (
                        <Box flexDirection={'row'}>
                            <Odds
                                odds={oddDetails.total_odds}
                                style={[
                                    stylesheet.smallTitle,
                                    {
                                        color: isAlreadySelected
                                            ? designSystem.colors.neutral900
                                            : ds.colorValue.text.primary,
                                    },
                                ]}
                            />
                        </Box>
                    )}
                </Box>
            </TouchableOpacity>
            <SizedBox value={8} />
        </Box>
    );
};

const stylesheet = StyleSheet.create({
    smallTitle: {
        fontSize: 13,
        lineHeight: 20,
        fontWeight: '600',
    },
});
